import React from 'react';
import { OverlayTrigger, Popover } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { useT } from '@spotify-internal/i18n-core';

type Props = {
  placement?: 'top' | 'bottom';
  children: React.ReactNode;
};

const Contents = styled.div`
  display: contents;
`;

const WrappedPopover = styled.div`
  animation: fadeIn 0.1s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export function LanguageSelectionTooltip(props: Props) {
  const t = useT();
  const { children } = props;
  const [enabled, setEnabled] = React.useState(false);

  let timeoutHandle: any;
  const ref: any = React.useRef(null);

  const mouseEnterHandler = () => {
    timeoutHandle = setTimeout(() => {
      setEnabled(true);
    }, 1000);
  };

  const mouseExitHandler = () => {
    if (timeoutHandle) clearTimeout(timeoutHandle);
    setEnabled(false);
  };
  return (
    <OverlayTrigger
      dir="ltr"
      placement="bottom"
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseExitHandler}
      overlay={
        enabled && (
          // @ts-ignore
          <WrappedPopover ref={ref}>
            <Popover
              colorSet="invertedLight"
              css="padding-block: 8px; padding-inline: 12px;"
            >
              <div dir="auto">
                {t(
                  'choose_language_prompt',
                  'Choose your preferred language.',
                  'Prompt for the user to change the language on the page',
                )}
              </div>
            </Popover>
          </WrappedPopover>
        )
      }
    >
      <Contents>{children}</Contents>
    </OverlayTrigger>
  );
}
